<template>
    <div class="HaulingCalculatorMenuPage">
        <SiteHeader/>

        <Container>
            <h1>Hauling Calculator</h1>
            <p>Create a Quote for a Customer or Analyze a Quote You Received.</p>

            <Button to="/resources/haulingcalc/give" class="primary lg">Create Quote</Button>
            <Button to="/resources/haulingcalc/analyze" class="primary lg">Analyze Quote</Button>
        </Container>

        <SiteFooter/>
    </div>
</template>


<script>
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

export default {
    name: 'HaulingCalculatorMenuPage',

    components: {
        SiteHeader,
        SiteFooter,
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.HaulingCalculatorMenuPage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        text-align: center;
        margin-bottom: 80px;
    }

    .SiteFooter {
        align-self: flex-end;
    }

    h1 {
        @extend %display-subtitle;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    p {
        @extend %display-description;
        margin-bottom: 40px;
    }

    .Button {
        margin: 0 15px;
    }
}
</style>
